import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { HotDocComponent } from "@components/hot-doc/hot-doc.component";
import { HotDoc } from "~app/common/components/hot-doc/hotdoc/doc";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ProduktdefinitionViewModel } from "../../../models/ProduktdefinitionViewModel";

@Component({
    selector: "rask-fargmarkning",
    templateUrl: "./fargmarkning.component.html",
    styleUrls: ["./fargmarkning.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BlockComponent,
        HotDocComponent,
        ButtonComponent
    ]
})
export class FargmarkningComponent implements OnChanges {
    hotDoc: HotDoc;
    @Input() rootForm: UntypedFormGroup;
    @Input() viewModel: ProduktdefinitionViewModel;

    private readonly raskModalService = inject(RaskModalService);

    initMatrisSettings = () => {
        this.hotDoc = this.viewModel.fargmarkning.matrisdata.fargmarkningMatris.getFargmarkning(this.raskModalService, this.rootForm,
            (startlangd, startdiameter) => this.viewModel.fargmarkning.matrisdata.grid.getCell(startlangd, startdiameter));
    };

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.viewModel) {
            this.initMatrisSettings();
        }
    }

    rensaFargmarkning() {
        const cells = this.hotDoc.selectedCells();
        this.viewModel.fargmarkning.matrisdata.fargmarkningMatris.rensaFargmarkering(this.hotDoc, cells);
    }

    setFargMarkning = (nummer: number ) => {
        const cells = this.hotDoc.selectedCells();
        this.viewModel.fargmarkning.matrisdata.fargmarkningMatris.setFargMarkning(this.hotDoc, nummer, cells);
    };
}
